import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Header from "../Header/Header";
import { isMobile } from "react-device-detect";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";
import { Redirect, withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { fetchAutos } from "../../actions/cars";
import store from "../../store";

class navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      models: []
    };
  }

  componentDidMount = () => {
    store.dispatch(fetchAutos()).then(() => this.fillAutos());
  };

  fillAutos = () => {
    this.setState({ models: store.getState().carsReducer.autos });
  };

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <div className="Navbar" id="header">
        {isMobile ? (
          <React.Fragment>
            <div className="MenuNavBar">
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={this.handleClick}
                className="MenuButton"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                open={this.state.open}
                onClose={this.handleClose}
                className="MenuNav"
                anchorEl={this.state.anchorEl}
              >
                <MenuItem
                  key={"1"}
                  selected={false}
                  onClick={this.props.onClick}
                >
                  {"COMO COMPRAR"}
                </MenuItem>
                <MenuItem key={"2"} selected={false}>
                  {"AUTOS EN STOCK"}
                </MenuItem>
                {this.state.models.map(model => (
                  <MenuItem
                    key={model.modelo}
                    selected={false}
                    onClick={() => {
                      this.props.handleSelection(model.modelo);
                      this.handleClose();
                    }}
                    className="MenuItem2"
                    id={model.modelo}
                  >
                    {model.modelo}
                  </MenuItem>
                ))}
                <MenuItem key={"9"} selected={false} onClick={this.handleClose}>
                  {"FAQ"}
                </MenuItem>
                <MenuItem
                  key={"10"}
                  selected={false}
                  onClick={this.handleClose}
                >
                  {"CONTACTO"}
                </MenuItem>
                ))
              </Menu>
            </div>
            <img src="./img/main-top-m.png" className="Top" id="header-top" />
          </React.Fragment>
        ) : (
          <Grid container>
            <Grid item xs={12} sm={12}>
              <img src="./img/main-top-3.png" className="Top" id="header-top" />
              <div className="Video-button-container">
                <img
                  src="./img/video-button.png"
                  className="Video-button"
                  onClick={this.props.onClick}
                />
              </div>
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}

export default withRouter(navbar);
